<template>
  <div class="container-fluid">
    <Breadcrumbs title="Carga Individual" main="Cargar Productos GS1" />
    <div class="row">
      <div class="col-12">
        <div class="card carga-card">
          <div class="card-body">
            <form class="carga-form" @submit.prevent="buscarYCargarGS1">
              <div class="carga-campo">
                <label class="carga-label" for="codigoGS1">Ingresa Un Codigo De Barras:</label>
                <input id="codigoGS1" v-model.trim="codigoGS1" type="text" inputmode="numeric" class="form-control carga-input"
                  :class="{ 'is-invalid': gs1Error }" placeholder="Producto" autocomplete="off" />
              </div>
              <button type="submit" class="btn btn-procesar" :disabled="!codigoGS1 || loadingGS1">
                {{ loadingGS1 ? "Procesando" : "Buscar y procesar" }}
                <span v-if="loadingGS1" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <vue-feather v-else type="search" size="16" />
              </button>
            </form>
            <p v-if="gs1Error" class="text-danger small mt-2 mb-0">{{ gs1Error }}</p>
            <div v-if="gs1PreviewUrl" class="mt-3 p-3 bg-light rounded">
              <p class="fw-semibold text-success mb-2">
                <vue-feather type="check-circle" size="18" class="me-1" />
                Imagen procesada correctamente
              </p>
              <img :src="gs1PreviewUrl" alt="Vista previa" class="gs1-preview-img" />
              <p class="text-muted small mt-2 mb-0">Código: {{ gs1Producto }} — Se procesará en segundo plano</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetch } from "@/services/api";
import Swal from "sweetalert2";

export default {
  name: "CargaIndividualGS1",
  data() {
    return {
      codigoGS1: "",
      loadingGS1: false,
      gs1Error: null,
      gs1PreviewUrl: null,
      gs1Producto: null,
    };
  },
  methods: {
    async buscarYCargarGS1() {
      if (!this.codigoGS1) return;
      let codigo = this.codigoGS1.trim().replace(/\s/g, "");
      if (!/^\d{5,14}$/.test(codigo)) {
        this.gs1Error = "El código debe tener entre 5 y 14 dígitos.";
        return;
      }
      if (codigo.length < 14) {
        codigo = codigo.padStart(14, "0");
      }
      this.gs1Error = null;
      this.gs1PreviewUrl = null;
      this.gs1Producto = null;
      this.loadingGS1 = true;
      const baseUrl = process.env.VUE_APP_API_BASE_URL || "http://localhost:3000";
      try {
        const response = await apiFetch(`${baseUrl}/api/imagenes/gs1/cargar`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ GTIN: [codigo] }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(data.error || data.message || `Error HTTP ${response.status}`);
        }
        this.gs1PreviewUrl = data.imageBase64;
        this.gs1Producto = data.producto;
        await Swal.fire({
          icon: "success",
          title: "Imagen procesada correctamente",
          text: "Se procesará en segundo plano y aparecerá en el Banco de Imágenes.",
        });
      } catch (error) {
        this.gs1Error = error.message || "No se pudo cargar desde GS1.";
      } finally {
        this.loadingGS1 = false;
      }
    },
  },
};
</script>

<style scoped>
.carga-card {
  border: none;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.05);
}

.carga-card .card-body {
  padding: 28px 28px 48px;
}

.carga-form {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 16px 44px;
}

.carga-campo {
  width: 100%;
  max-width: 295px;
}

.carga-label {
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  color: #3d3d3d;
}

.carga-input {
  height: 34px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  font-size: 15px;
  color: #3d3d3d;
}

.carga-input::placeholder {
  color: #898989;
}

.carga-input:focus {
  border-color: #5c61f2;
  box-shadow: 0 0 0 0.15rem rgba(92, 97, 242, 0.15);
}

.btn-procesar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 36px;
  margin-bottom: 0;
  padding: 0 24px;
  border: none;
  border-radius: 30px;
  background-color: #5c61f2;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
  transition: background-color 0.15s ease, transform 0.15s ease, box-shadow 0.15s ease;
}

.btn-procesar:hover:not(:disabled) {
  background-color: #4b50e0;
  color: #fff;
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(92, 97, 242, 0.3);
}

.btn-procesar:disabled {
  background-color: #5c61f2;
  color: #fff;
  opacity: 0.65;
}

.gs1-preview-img {
  max-width: 300px;
  max-height: 200px;
  object-fit: contain;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}
</style>
